<template>
	<div>
		<div class="map">
			<div class="chart" id="mapChart"></div>
			<div class="lenged">
				<div class="lengedList fz14" v-for="item in lengedList" :key="item.value">
					<div class="circularBox" :style="'width:'+ lengedList[lengedList.length-1].value +'px;'">
						<span class="circular" :style="'width:'+ item.value +'px;height:'+ item.value + 'px'"></span>
					</div>
					<span class="name">{{item.name}}</span>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	// import { mapState, mapActions, mapMutations} from 'vuex'
	import echarts from 'echarts'
	import chinaJson from 'echarts/map/json/china.json'

	export default {
		data() {
			return {
				myChart: null,
				lengedList: []
			}
		},
		computed: {
			...Vuex.mapState('supervisor', ['GetReportListArr']),
			...Vuex.mapState('visualization', ['regionAVGScoreList','setDateArr','regionbreadcrumbList','trigger'])
		},
		watch: {
			regionAVGScoreList(old, news) {
				let _this = this;
				if (this.regionAVGScoreList) {
					this.trigger.hospital = false;
					this.$nextTick(() => {
						_this.drawMapChart();
					})
				}
			}
		},
		mounted() {
			//左侧导航收起时右侧图联动
			let _this = this;
			this.$nextTick(() => {
				_this.drawMapChart();
			})
			this.erd.listenTo(document.getElementsByClassName("el-main"), function(element) {
				if (_this.myChart) {
					_this.drawMapChart();
				}
			})
		},
		methods: {
			...Vuex.mapMutations('visualization',['setregionbreadcrumbList']),
			drawMapChart() {				
				//初始化echarts实例
				echarts.registerMap('china', chinaJson)
				let dom = document.getElementById('mapChart');
				this.myChart = echarts.init(dom);
				let numCount = 0;
				this.regionAVGScoreList.forEach(item => {
					numCount = Math.max(numCount, item.SampledNum);
				})
				
				let firstParagraph = Math.floor((Math.floor(numCount / 3))/10)*10;
				let secondparagraph = Math.floor(Math.floor((numCount / 3) * 2)/10)*10;
				this.lengedList=[{
								name:'0 ~ ' + firstParagraph,
								value:8
							},{
								name:firstParagraph + ' ~ ' + secondparagraph,
								value:12
							},{
								name:secondparagraph + ' ~ ' + numCount,
								value:16
							}]
				let data = this.regionAVGScoreList.map(item => {
					let SampledNum = 0;
					if (item.SampledNum <= firstParagraph) {
						SampledNum = 80;
					} else if (item.SampledNum <= secondparagraph) {
						SampledNum = 120;
					} else if (secondparagraph < item.SampledNum) {
						SampledNum = 160;
					}
					return {
						name: item.RegionName,
						value: SampledNum,
						sampledNum: item.SampledNum,
						RegionGuid: item.RegionGuid,
						HospitalCount: item.HospitalCount
					}
				})

				let param = {};
				let arr = this.regionAVGScoreList.map(item => {
					param[item.RegionName] = [item.Lat, item.Lon]
					return param
				})
				let geoCoordMap = arr[0];
				let convertData = function(data) {
					let res = [];
					for (let i = 0; i < data.length; i++) {
						let geoCoord = geoCoordMap[data[i].name];
						if (geoCoord) {
							res.push({
								name: data[i].name+'('+ data[i].HospitalCount+')',
								isname:data[i].name,
								value: geoCoord.concat(Number(data[i].value)),
								sampledNum: data[i].sampledNum,
								RegionGuid: data[i].RegionGuid,
								HospitalCount: data[i].HospitalCount
							});
						}
					}
					return res;
				};
				let option = {
					tooltip: {
						trigger: 'item',
						formatter: function(params) {
							return `${params.data.name}:${params.data.sampledNum}份`;
						},
					},
					//布局e
					geo: {
						show: true,
						map: 'china',
						zoom: 1.23, //地图绽放
						label: {
							normal: {
								show: false,
								textStyle: {
									color: '#fff'
								}
							},
							emphasis: {
								show: false,
							}
						},
						roam: false, //是否开启鼠标缩放和平移漫游
						itemStyle: {
							normal: {
								areaColor: 'rgba(59, 143, 253, 0.05)',
								borderColor: '#3B8FFD',
								borderWidth: 2,
								shadowColor: '#3B8FFD', //阴影
								shadowBlur: 20,
								shadowOffsetX: 0,
								shadowOffsetY: 0
							},
							emphasis: {
								areaColor: 'rgba(59, 143, 253, .5)',
								color: '#fff'
							}
						}
					},
					series: [{
						type: 'effectScatter',
						coordinateSystem: 'geo',
						data: convertData(data),
						symbolSize: function(val) {
							return val[2] / 10;
						},
						showEffectOn: 'render',
						rippleEffect: {
							brushType: 'stroke'
						},
						hoverAnimation: true,
						label: {
							normal: {
								formatter: '{b}',
								position: 'right',
								show: true,
								color: '#ffffff',
								fontWeight:'bolder',
								fontSize:this.fontSize(0.14)
							}
						},
						itemStyle: {
							normal: {
								color: '#5CF4C1',
								shadowBlur: 10,
								shadowColor: '#5CF4C1'
							}
						},
						zlevel: 1
					}]
				};
				dom.style.height = this.getClientHeight() - 75 + 'px';
				if(option && typeof option === "object") {
					this.myChart.setOption(option, true);
					this.myChart.off('click'); //清除联系点击
					this.myChart.on('click', (params) => {
						this.setregionbreadcrumbList();
						this.regionbreadcrumbList.push(this.setDateArr.data[0] + '-' + this.setDateArr.data[1]);
						this.GetReportListArr.type = params.data.isname;
						this.regionbreadcrumbList.push(params.data.isname);
						this.regionbreadcrumbList.push('region');
						this.regionbreadcrumbList.push(params.data.RegionGuid);
						this.GetReportListArr.name = params.data.isname;
						this.GetReportListArr.regionId = params.data.RegionGuid;
						this.$router.push("/home/visualization/visRegion");
					});
				}
				this.myChart.resize(); //区域更新
				window.addEventListener("resize", () => {
					this.myChart.resize();
				});
			},
			getClientHeight() {
				let clientHeight = 0;
				if (document.body.clientHeight && document.documentElement.clientHeight) {
					clientHeight = (document.body.clientHeight < document.documentElement.clientHeight) ? document.body.clientHeight :
						document.documentElement.clientHeight;
				} else {
					clientHeight = (document.body.clientHeight > document.documentElement.clientHeight) ? document.body.clientHeight :
						document.documentElement.clientHeight;
				}
				return clientHeight;
			}
		}
	}
</script>
